import AboutWrapper from 'components/AboutWrapper/AboutWrapper';
import React, { useEffect, useState } from 'react';
import {
  STPaginationButton,
  StArticleRichText,
  StArticleTitle,
  StBox,
  StRichText,
  StTypography,
} from './Glossary.styles';
import { Text, NextImage } from '@sitecore-jss/sitecore-jss-nextjs';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

const fallBackTabItem: any = {
  id: '',
  url: '',
  name: '',
  displayName: '',
  fields: {
    link: { value: { href: '' } },
  },
};

const GlossaryContent: React.FC<any> = (props) => {
  const [selectedOption, setSelectedOption] = useState('');
  const [filteredGlossaryWords, setFilteredGlossaryWords] = useState<any[]>([]);
  const [alphabetList, setAlphabetList] = useState<string[]>([]);
  const tabLinks = props?.fields?.tabLinks || [fallBackTabItem];
  const activeTab = props?.fields?.activeTab || fallBackTabItem;
  const icon = props?.fields?.icon;
  const title = props?.fields?.title;
  const content = props?.fields?.content;
  const showNumericWordsFirst = props?.fields?.showNumericWordsFirst?.value;
  const [combinedlistOfGlossary, setCombinedlistOfGlossary] = useState<any[]>([]);
  const sortAlphabetically = (wordList: any[]) => {
    return wordList.sort((a, b) => {
      const wordA = a?.fields?.heading?.value?.toLowerCase();
      const wordB = b?.fields?.heading?.value?.toLowerCase();
      if (wordA < wordB) return -1;
      if (wordA > wordB) return 1;
      return 0;
    });
  };

  useEffect(() => {
    setSelectedOption(props?.fields?.showAllText?.value.toLowerCase() || 'all');
  }, [props?.fields?.showAllText]);

  useEffect(() => {
    const listOfGlossaryWords = props?.fields?.listOfGlossaryAlphaWords || [];
    const listOfGlossaryNumericWords = props?.fields?.listOfGlossaryNumericWords || [];

    const result = showNumericWordsFirst
      ? [
          ...sortAlphabetically(listOfGlossaryNumericWords),
          ...sortAlphabetically(listOfGlossaryWords),
        ]
      : [
          ...sortAlphabetically(listOfGlossaryWords),
          ...sortAlphabetically(listOfGlossaryNumericWords),
        ];

    setCombinedlistOfGlossary(result);
  }, [
    props?.fields?.listOfGlossaryAlphaWords,
    props?.fields?.listOfGlossaryNumericWords,
    showNumericWordsFirst,
  ]);

  useEffect(() => {
    const all = [
      props?.fields?.showAllText?.value,
      ...combinedlistOfGlossary.map((item: any) => {
        return item?.fields?.heading?.value?.charAt(0).toUpperCase();
      }),
    ];

    setAlphabetList([...new Set(all)]);
  }, [combinedlistOfGlossary, props?.fields?.showAllText]);

  useEffect(() => {
    const result: any = combinedlistOfGlossary.filter((item: any) => {
      if (selectedOption.toLowerCase() === 'all') {
        return true;
      }
      return item?.fields?.heading?.value?.toLowerCase().startsWith(selectedOption.toLowerCase());
    });
    setFilteredGlossaryWords(result);
  }, [combinedlistOfGlossary, selectedOption]);

  const AlphabetPagination = ({ onClick }: any) => {
    return (
      <Grid>
        {alphabetList.map((letter) => (
          <STPaginationButton
            className={selectedOption.toLowerCase() === letter.toLowerCase() ? 'active' : ''}
            key={letter}
            onClick={() => {
              onClick(letter);
            }}
          >
            {letter}
          </STPaginationButton>
        ))}
      </Grid>
    );
  };

  const handleAlphabetPagination = (letter: string) => {
    setSelectedOption(letter);
  };

  return (
    <AboutWrapper tabLinks={tabLinks} activeTab={activeTab}>
      <Grid id="content-with-filter">
        <Grid id="content">
          <StBox>
            <NextImage field={icon} />
            <StTypography>
              <Text field={title} />
            </StTypography>
          </StBox>
          <StRichText field={content} />
        </Grid>
        <Grid id="alphabet">
          <AlphabetPagination onClick={handleAlphabetPagination} />
        </Grid>
      </Grid>
      <Grid id="articles">
        {filteredGlossaryWords.map((article: any, index: number) => (
          <>
            <Grid key={index}>
              <StArticleTitle>
                <Text field={article?.fields?.heading} />
              </StArticleTitle>
              <StArticleRichText field={article?.fields?.content} />
            </Grid>
            <Divider sx={{ marginBottom: '30px' }} />
          </>
        ))}
        {filteredGlossaryWords.length === 0 && (
          <>
            <Grid>
              <Typography variant="h5">No Glossary Found</Typography>
            </Grid>
          </>
        )}
      </Grid>
    </AboutWrapper>
  );
};

export default GlossaryContent;
